export default "<ion-app>\n  <app-main-menu></app-main-menu>\n  <ion-router-outlet id=\"main\"></ion-router-outlet>\n</ion-app>\n";